import styled from 'styled-components/native';

export default styled.TouchableOpacity<{ inset: number }>`
  flex-direction: row;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  padding: ${({ inset }) => inset || 0}px 15px 15px 15px;
`;
